<template>
    <!-- 添加设备到分组 -->
    <div class="">
      <v-dialog
      class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="this.groupId == 0 ? dialogTitleadd : dialogTitleedit"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >

        <v-form ref="form" :model="ruleForm" :rules="rules">

          <v-form-item prop="group_id">
            <template slot="label">
              <span class="required">*</span>
              <span>分组名称</span>
            </template>
              <v-select class="" id="group_id" :placeholder="groupOptions.length > 0 ? '请选择' : '请先新建分组'" name="groupName" v-model="ruleForm.group_id" :options="groupOptions"></v-select>
            </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>

    </div>

</template>

  <script>
// import { copy } from '@/common/libs/utils';

  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      devId:{},
      groupId:{}
    },
    data() {
      return {
        rules: {

        },
        ruleForm:{
          group_id: "",
          app_id: sessionStorage.getItem("appid") || "",
          id: 0
        },
        dialogTitleadd: "添加设备到分组",
        dialogTitleedit: "编辑设备所在分组",
        isShow:false,
        enable:'on',
        upTips:true,
        groupOptions:[]
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){
        this.getData()
        this.ruleForm.group_id = this.groupId == 0 ? '' : this.groupId
      },
      async getData(){
        const subData = {
          app_id: sessionStorage.getItem("appid") || "",
          page_num: 1,
          page_size: 10000,
        };
        const res = await this.$post(
          "/td/td-iot-api/iot/group/page/v1",
          subData,
          false
        );
        if(res.code === 0){
          this.groupOptions = res.data.list.map((item)=>{
            return {
              label: item.group_name,
              value: item.id,
            }
          })
        }else{
          if(res.code == '100410'){
            setTimeout(() => {
              this.getData()
            },1000)
          }else{
            this.$message.error(res.msg);
          }
        }
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        this.ruleForm.id = Number(this.devId)
        let submitData = { ...this.ruleForm };
        this.$post("/td/td-iot-api/iot/dev/move/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">

  </style>
